import React from "react";
import Rating from "@mui/material/Rating";

const WalmartSearchCard = ({ product, loading, onSelect }) => {
  const handleClick = () => {
    if (!loading && product?.product_id) {
      onSelect(product);
    }
  };

  return (
    <div
      className="flex flex-col w-full border border-primary/80 bg-primary-bg p-4 mt-4 rounded-2xl cursor-pointer"
      onClick={handleClick}
    >
      <div className="flex items-center">
        <div className="inline-block top-20 left-20 gap-0 w-[40%]">
          {!product?.thumbnail || loading ? (
            <div
              className="flex items-center justify-center w-full h-32 bg-gray-300 rounded dark:bg-secondary"
              style={{
                border: "0.5px solid #76F99B",
                background: "rgba(118, 249, 155, 0.35)",
                borderRadius: "30px",
              }}
            >
              <svg
                className="w-8 h-8 text-gray-200 dark:text-gray-600"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 18"
              >
                <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
              </svg>
            </div>
          ) : (
            <div className="flex items-center justify-center w-[150px] h-[150px] bg-white rounded-lg">
              <img
                src={product.thumbnail}
                alt={product.title || "Product"}
                className="object-contain w-full h-full rounded-lg"
              />
            </div>
          )}
        </div>

        <div className="text-primary text-left w-[60%] px-4">
          {!loading && (
            <>
              <div
                className="text-white font-bold"
                style={{
                  fontSize: "12px",
                }}
              >
                {product?.brand || ""}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {product?.title
                  ? product.title.length > 60
                    ? product.title.substring(0, 60) + "..."
                    : product.title
                  : "--"}
              </div>

              <div className="flex items-end mt-1">
                <Rating
                  name="read-only"
                  value={Number(product?.rating || 0)}
                  precision={0.1}
                  readOnly
                  style={{
                    fontSize: "13px",
                    color: "#76F99B",
                  }}
                />
                <span
                  className="text-white ml-1"
                  style={{
                    fontSize: "10px",
                  }}
                >
                  {product?.rating || 0} ({product?.reviews || 0})
                </span>
              </div>

              <div
                className="mt-2"
                style={{
                  fontSize: "0.8rem",
                }}
              >
                <div className="text-white">
                  ID:{" "}
                  <span className="font-mono">
                    {product?.product_id || product?.us_item_id || "--"}
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="flex items-center mt-4 justify-between">
        <div className="inline-block left-20 gap-0 w-[40%]">
          <div
            className="box mt-2 group border border-primary rounded-lg p-3 bg-secondary-bg relative flex justify-between"
            style={{
              fontSize: "14px",
              width: "fit-content",
              marginLeft: "auto",
            }}
          >
            <p className="text-primary">
              {product?.price?.current != null
                ? `$${product.price.current}`
                : "-"}
            </p>
          </div>
        </div>
        <div className="text-primary text-left w-[60%] px-4">
          <div className="mt-2 rounded-lg p-3 bg-secondary-bg relative">
            <h3
              className="text-white"
              style={{
                fontSize: "13px",
                textWrap: "nowrap",
              }}
            >
              {product?.availability || "Availability unknown"}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalmartSearchCard;

